export const localesMap = {
  rus: 'ru',
  ukr: 'uk',
  rum: 'ro',
};
